export default {
  'Add Cut': 'Schnitt hinzufügen',
}